export default {"src":"/_next/static/media/mysql-icon.a7c69927.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};